var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"10","viewBox":"0 0 18 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.501583 1.42429L1.39951 0.526366L8.9996 8.12646L16.6001 0.526367L17.498 1.42429L9.44859 9.47337C9.20056 9.7214 8.79869 9.7214 8.55066 9.47337L0.501583 1.42429Z","fill":"#f36633"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }